import React from "react";
import { Link } from "react-router-dom";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import Diversity3RoundedIcon from "@mui/icons-material/Diversity3Rounded";
import RecordVoiceOverRoundedIcon from "@mui/icons-material/RecordVoiceOverRounded";
import TipsAndUpdatesRoundedIcon from "@mui/icons-material/TipsAndUpdatesRounded";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

const productSections = [
  {
    title: "Career Growth",
    items: [
      {
        title: "Priority DM",
        description: "Quick Expert Help Instantly",
        icon: MailOutlineRoundedIcon,
        to: "/priority-dm",
      },
      {
        title: "Referrals",
        description: "Get Referred By Professionals",
        icon: Diversity3RoundedIcon,
        to: "/referral-request",
      },
    ],
  },
  {
    title: "Interview Preparation",
    items: [
      {
        title: "Mock Interviews",
        description: "Practice Real Interviews",
        icon: RecordVoiceOverRoundedIcon,
        to: "/mentors-list",
      },
      {
        title: "Interview Prep",
        description: "Structured Guidance & Tips",
        icon: TipsAndUpdatesRoundedIcon,
        to: "/mentors-list",
      },
    ],
  },
  {
    title: "Profile Improvement",
    items: [
      {
        title: "Resume Review",
        description: "Improve Your Resume With Feedback",
        icon: DescriptionOutlinedIcon,
        to: "/mentors-list",
      },
    ],
  },
];

const sectionTitleClassName =
  "mb-5 text-[11px] font-semibold uppercase tracking-[0.08em] text-[#a9a9b5]";

const cardClassName =
  "group flex w-full min-w-0 items-start gap-3 rounded-2xl px-3 py-2 transition-all duration-200 hover:bg-[#f3f1ff]";

const iconWrapClassName =
  "mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-[10px] bg-[#d9d2ff] text-[#2b2177] transition-transform duration-200 group-hover:scale-105";

const ProductsPanel = ({ onNavigate }) => {
  return (
    <div className="rounded-[28px] bg-white p-4 shadow-[0_24px_70px_rgba(27,31,59,0.1)] sm:p-6">
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-[1fr_1fr_0.95fr] lg:gap-8">
        {productSections.map((section) => (
          <div key={section.title} className="min-w-0">
            <p className={sectionTitleClassName}>{section.title}</p>
            <div className="space-y-3">
              {section.items.map((item) => {
                const Icon = item.icon;

                return (
                  <Link
                    key={item.title}
                    to={item.to}
                    className={cardClassName}
                    onClick={onNavigate}
                  >
                    <span className={iconWrapClassName}>
                      <Icon sx={{ fontSize: 18 }} />
                    </span>
                    <span className="min-w-0">
                      <span className="block text-[14px] font-semibold leading-5 text-[#232136]">
                        {item.title}
                      </span>
                      <span className="block text-[11px] leading-4 text-[#8d8c99]">
                        {item.description}
                      </span>
                    </span>
                  </Link>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 px-1 text-center text-[12px] leading-5 text-[#3a3755] sm:px-0">
        <span>Not Sure Where To Start? </span>
        <Link
          to="/products"
          className="font-semibold text-[var(--primarty-text-color)] transition-opacity duration-200 hover:opacity-80"
          onClick={onNavigate}
        >
          Explore
        </Link>
      </div>
    </div>
  );
};

const Products = ({ embedded = false, onNavigate }) => {
  if (embedded) {
    return <ProductsPanel onNavigate={onNavigate} />;
  }

  return (
    <section className="bg-[#f7f8ff] px-4 pb-12 pt-24 sm:px-8 sm:pt-28 lg:px-12">
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 max-w-2xl">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.16em] text-[var(--primarty-text-color)]">
            Products
          </p>
          <h1 className="text-2xl font-bold leading-tight text-[#17142b] sm:text-4xl">
            Career support products built around interviews, referrals, and profile growth.
          </h1>
          <p className="mt-3 max-w-xl text-sm leading-6 text-[#67657a] sm:text-base">
            Explore the services designed to help you prepare faster, connect with professionals, and improve the materials that shape your applications.
          </p>
        </div>

        <ProductsPanel onNavigate={onNavigate} />
      </div>
    </section>
  );
};

export default Products;
